"use client"

import { LocalizedLink } from "@/shared/components/i18n/localized-link"
import { Button } from "@/shared/components/ui/button"

export default function AppNotFound() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4">
      <h1 className="text-7xl font-bold text-foreground">404</h1>

      <h2 className="mt-4 text-xl font-semibold text-foreground">
        Page not found
      </h2>

      <p className="mt-2 max-w-md text-center text-muted-foreground">
        This page doesn&apos;t exist within the app. It may have been moved or
        removed.
      </p>

      <Button asChild className="mt-8">
        <LocalizedLink href="/">Go Home</LocalizedLink>
      </Button>
    </div>
  )
}
